import { Badge } from '@/components/ui/badge';
import type { VacancyStatus } from '@/types/recruitment';

const STATUS_CONFIG: Record<VacancyStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  DRAFT: { label: 'Draft', variant: 'secondary' },
  UNDER_REVIEW: { label: 'Under review', variant: 'warning' },
  ACTIVE: { label: 'Active', variant: 'success' },
  PAUSED: { label: 'Paused', variant: 'secondary' },
  CANCELLED: { label: 'Cancelled', variant: 'destructive' },
  CLOSED: { label: 'Closed', variant: 'outline' },
  ARCHIVED: { label: 'Archived', variant: 'outline' },
};

export function VacancyStatusBadge({ status }: { status: VacancyStatus }) {
  const config = STATUS_CONFIG[status];
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
